import React from 'react';
import * as S from './FooterNew.styles';

const FooterNew = () => {
  const gotoTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <S.FooterContainer>
      <footer className="footer">
        <div className="footer-wrapper">
          <a className="footer-btn-arrow" onClick={gotoTop}>
            <img
              src={'https://assets-gos3.goibibo.com/myp_incentive_arrow_footer-1697785564.png'}
              alt=""
            />
          </a>
        </div>
      </footer>
    </S.FooterContainer>
  );
};

export default FooterNew;
